import React from "react";
import "./Works.css";
import LogoLEA from "../../img/logo.png";
import LogoESISA from "../../img/logoESISA.png";

import { motion } from "framer-motion";
import { Link } from "react-scroll";

const Works = () => {
  return (
    <>
      <div className="works" id="works">
        {/* Section gauche */}
        <div className="w-left">
          <div className="awesome">
            <span className="tacm">Découvrez</span>
            <span className="tacm">ESISA Analytica</span>
            <span className="tacm">
              ESISA Analytica est un laboratoire de recherche de pointe dédié à
              l'intelligence artificielle et à l'analyse avancée des données.
              <br />
              Nos experts travaillent sur des solutions innovantes en deep
              learning, machine learning et cybersécurité.
              <br />
              Rejoignez-nous pour explorer l'avenir de l'IA et repousser les
              limites de la technologie.
            </span>
            <Link className="tacm" to="contact" smooth={true} spy={true}>
              <button className="button s-button">Creez une SaaS IA ?</button>
            </Link>
            <div
              className="blur s-blur1"
              style={{ background: "#ABF1FF94" }}
            ></div>
          </div>
        </div>

        {/* Section droite - w-right doit être dans .works */}
        <div className="w-right">
          <motion.div
            initial={{ rotate: 180 }}
            whileInView={{ rotate: 360 }}
            viewport={{ margin: "-40px" }}
            transition={{ duration: 3.5, type: "spring" }}
            className="w-mainCircle"
          >
            <div className="w-secCircle">
              <img src={LogoESISA} alt="Logo ESISA" />
            </div>
            <div className="w-secCircle">
              <img src={LogoESISA} alt="Logo ESISA" />
            </div>
            <div className="w-secCircle">
              <img src={LogoLEA} alt="Logo LEA" />
            </div>
            <div className="w-secCircle">
              <img src={LogoESISA} alt="Logo ESISA" />
            </div>
            <div className="w-secCircle">
              <img src={LogoESISA} alt="Logo ESISA" />
            </div>
          </motion.div>
          <div className="w-backCircle blueCircle"></div>
          <div className="w-backCircle yellowCircle"></div>
          <div className="w-backCircle2 blueCircle2"></div>
          <div className="w-backCircle2 yellowCircle2"></div>
        </div>
      </div>
    </>
  );
};

export default Works;
